var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 65,
    rx: 15.5,
    fill: "#FFFDFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 65,
    rx: 15.5,
    stroke: "#EDF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.079 18.0459C21.2876 14.9373 25.5254 15.927 31.957 17.3783C35.9632 18.2832 40.957 18.5752 46.7125 18.013C49.0209 17.7875 51.4695 17.386 54 16.7909C46.2432 20.8682 37.571 23.5099 28.8813 24.8107C25.7856 25.2516 23.114 24.9308 21.887 23.759L20.3167 22.6192C21.0246 21.1213 20.5806 19.5897 20.079 18.0459ZM19.5693 18.5026C19.1281 18.5829 19.0588 19.0725 18.998 19.3536C17.3666 20.9631 15.0995 20.7298 12.5889 19.9421C12.1893 19.8034 11.5434 20.2086 12.4906 20.5822C13.1565 20.8223 14.3223 21.1638 18.1409 21.0977C18.4712 21.6721 19.0111 22.1008 19.7487 22.3012C20.2291 21.2523 20.0431 19.8509 19.5693 18.5026Z",
    fill: "#E31D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.079 31.0459C21.2876 27.9373 25.5254 28.927 31.957 30.3783C35.9632 31.2832 40.957 31.5752 46.7125 31.013C49.0209 30.7875 51.4695 30.386 54 29.7909C46.2432 33.8682 37.571 36.5099 28.8813 37.8107C25.7856 38.2516 23.114 37.9308 21.887 36.759L20.3167 35.6192C21.0246 34.1213 20.5806 32.5897 20.079 31.0459ZM19.5693 31.5026C19.1281 31.5829 19.0588 32.0725 18.998 32.3536C17.3666 33.9631 15.0995 33.7298 12.5889 32.9421C12.1893 32.8034 11.5434 33.2086 12.4906 33.5822C13.1565 33.8223 14.3223 34.1638 18.1409 34.0977C18.4712 34.6721 19.0111 35.1008 19.7487 35.3012C20.2291 34.2523 20.0431 32.8509 19.5693 31.5026Z",
    fill: "#E31D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.079 44.0459C21.2876 40.9373 25.5254 41.927 31.957 43.3783C35.9632 44.2832 40.957 44.5752 46.7125 44.013C49.0209 43.7875 51.4695 43.386 54 42.7909C46.2432 46.8682 37.571 49.5099 28.8813 50.8107C25.7856 51.2516 23.114 50.9308 21.887 49.759L20.3167 48.6192C21.0246 47.1213 20.5806 45.5897 20.079 44.0459ZM19.5693 44.5026C19.1281 44.5829 19.0588 45.0725 18.998 45.3536C17.3666 46.9631 15.0995 46.7298 12.5889 45.9421C12.1893 45.8034 11.5434 46.2086 12.4906 46.5822C13.1565 46.8223 14.3223 47.1638 18.1409 47.0977C18.4712 47.6721 19.0111 48.1008 19.7487 48.3012C20.2291 47.2523 20.0431 45.8509 19.5693 44.5026Z",
    fill: "#E31D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0a5ad357779e7b1128efc4c83e6c607c.svg";
export { ForwardRef as ReactComponent };